import { MantenimientoRespository } from './mantenimiento.repository';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { abrirStatementRequest, aprobarStatementRequest, BuscarNavesRequest, BuscarNaveViajeRequest, cambiarEstadoNaveRequest, cerrarNaveRequest, emitirStatementRequest, envioCorreoRequest, getFormatosHtmlRequest, getMailRequest, permisosUsuarioRequest, TNSNaveViajeRequest, validacionAnulacionPrefacturadasRequest } from '../nave-viaje/domain/nave-viaje.request';
import { abrirStatementResponse, BuscarNavesResponse, BuscarNaveViajeResponse, cambioEstadoResponse, emitirStatementResponse, EnvioCorreoResponse, getFormatosHtmlResponse, getMailIntegradorResponse, permisosUsuarioResponse, TNSNaveViajeResponse, validacionAnulacionPrefacturadasResponse } from '../nave-viaje/domain/nave-viaje.response';
import { BuscarPaquetesRequest, EmbalajeTNSRequest } from '../embalajes/domain/embalajes.request';
import { BuscarPaquetesResponse, tnsEmbalajeResponse } from '../embalajes/domain/embalajes.response';
import { BuscarPuertosRequest, PuertoTNSRequest } from '../puertos/domain/puertos.request';
import { BuscarPuertosResponse, tnsPuertoResponse } from '../puertos/domain/puertos.response';
import { BuscarCamposRequest, CamposTNSRequest, ListarServiciosRequest } from '../mantenimiento-de-campos/domain/mantenimiento-de-campos.request';
import { BuscarCamposResponse, listarServiciosResponse, tnsCamposResponse } from '../mantenimiento-de-campos/domain/mantenimiento-de-campos.response';
import { AreasTNSRequest, BuscarAreasRequest, BuscarCargosRequest, BuscarCargosYAutorizadosByAreaRequest, RelAreaCargoTNSRequest } from '../areas/domain/areas.request';
import { buscarAreasResponse, buscarCargosResponse, getCargoResAutorizarResponse, RelAreaCargoTNSResponse, TransaccionAreasResponse } from '../areas/domain/areas.response';
import { GenerarFichaPersonalRequest, getArchivosEmpleadoRequest, getFormatosFichaEmpleadoRequest, ListarEmpleadosRequest, TnsFormatosFichaEmplRequest, TransaccionEmpleadoRequest, ValidacionUsrWebEmpleadosRequest } from '../empleados/domain/empleados.request';
import { buscarEmpleadosResponse, GenerarFichaPersonalResponse, getArchivosEmpleadoResponse, getFormatosFichaEmplResponse, TnsFormatosFichaEmplResponse, TransaccionEmpleadoResponse, validacionUsWebEmpleadoResponse } from '../empleados/domain/empleados.response';
import { CargoTNSResponse } from '../cargos/domain/cargos.response';
import { CargosTNSRequest } from '../cargos/domain/cargos.request';
import { R_GetAgenteContactosByIdRequest, R_GetAgentePuertoByIdRequest, R_GetBandejaAgentePuertoRequest, R_GetBandejaAgentesRequest, R_GetListadosAgentePuertoRequest, R_TransaccionAgentePuertoRequest, R_TransaccionAgentesRequest } from '../directorio-agente-puerto/domain/directorio-agente-puerto.request';
import { AgenteContactosByIdDTO, AgentePuertoByIdDTO, BandejaAgentePuertoDTO, BandejaAgentesDTO, ListadoAgentePuertoDTO, ResponseTransaccionAgentePuertoDTO, ResponseTransaccionAgentesDTO } from '../directorio-agente-puerto/domain/directorio-agente-puerto.response';

@Injectable({
  providedIn: 'root'
})
export class MantenimientoService implements MantenimientoRespository {

  constructor(
    private readonly http: HttpClient
  ) { }

  //#region NAVE-VIAJE
  BuscarNaves(fd: BuscarNavesRequest): Observable<BuscarNavesResponse> {
    return this.http.post<BuscarNavesResponse>(`${environment.PATH_API}/mantenimiento/ObtenerNaves`, fd);
  }
  BuscarNaveViaje(fd: BuscarNaveViajeRequest): Observable<BuscarNaveViajeResponse> {
    return this.http.post<BuscarNaveViajeResponse>(`${environment.PATH_API}/mantenimiento/BuscarNaveViaje`, fd);
  }
  TNSNaveViaje(fd: TNSNaveViajeRequest): Observable<TNSNaveViajeResponse> {
    return this.http.post<TNSNaveViajeResponse>(`${environment.PATH_API}/mantenimiento/TransaccionNaveViaje`, fd);
  }
  emitirStatement(fd: emitirStatementRequest): Observable<emitirStatementResponse> {
    return this.http.post<emitirStatementResponse>(`${environment.PATH_API}/mantenimiento/EmitirStatement`, fd);
  }
  abrirStatement(fd: abrirStatementRequest): Observable<abrirStatementResponse> {
    return this.http.post<abrirStatementResponse>(`${environment.PATH_API}/mantenimiento/abrirStatement`, fd);
  }
  aprobarStatement(fd: aprobarStatementRequest): Observable<emitirStatementResponse> {
    return this.http.post<emitirStatementResponse>(`${environment.PATH_API}/mantenimiento/aprobarStatement`, fd);
  }
  cerrarNave(fd: cerrarNaveRequest): Observable<abrirStatementResponse> {
    return this.http.post<abrirStatementResponse>(`${environment.PATH_API}/mantenimiento/cerrarNave`, fd);
  }
  getFormatoHtml(fd: getFormatosHtmlRequest): Observable<getFormatosHtmlResponse> {
    return this.http.post<getFormatosHtmlResponse>(`${environment.PATH_API}/mantenimiento/getFormatoHtml`, fd);
  }
  enviarCorreo(fd: envioCorreoRequest): Observable<EnvioCorreoResponse> {
    return this.http.post<EnvioCorreoResponse>(`${environment.PATH_API}/generales/enviarCorreoApi`, fd);
  }
  aplicacionesPermisosUsuario(fd: permisosUsuarioRequest): Observable<permisosUsuarioResponse> {
    return this.http.post<permisosUsuarioResponse>(`${environment.PATH_API}/mantenimiento/aplicacionesPermisosUsuario`, fd);
  }
  validarAnulacionPrefacturadas(fd: validacionAnulacionPrefacturadasRequest): Observable<validacionAnulacionPrefacturadasResponse> {
    return this.http.post<permisosUsuarioResponse>(`${environment.PATH_API}/mantenimiento/validacionAnulacionPrefacturadas`, fd);
  }
  cambioEstadoNave(fd: cambiarEstadoNaveRequest): Observable<cambioEstadoResponse> {
    return this.http.post<cambioEstadoResponse>(`${environment.PATH_API}/mantenimiento/cambioEstadoNave`, fd);
  }
  getMailIntegrador(fd: getMailRequest): Observable<getMailIntegradorResponse> {
    return this.http.post<getMailIntegradorResponse>(`${environment.PATH_API}/mantenimiento/getMailIntegrador`, fd);
  }
  //#endregion

  //#region EMBALAJES
  buscarPaquetes(fd: BuscarPaquetesRequest): Observable<BuscarPaquetesResponse> {
    return this.http.post<BuscarPaquetesResponse>(`${environment.PATH_API}/mantenimiento/buscarPaquetes`, fd);
  }
  transaccionEmbalaje(fd: EmbalajeTNSRequest): Observable<tnsEmbalajeResponse> {
    return this.http.post<tnsEmbalajeResponse>(`${environment.PATH_API}/mantenimiento/transaccionEmbalaje`, fd);
  }
  //#endregion

  //#region PUERTOS
  buscarPuertos(fd: BuscarPuertosRequest): Observable<BuscarPuertosResponse> {
    return this.http.post<BuscarPuertosResponse>(`${environment.PATH_API}/mantenimiento/buscarPuerto`, fd);
  }
  transaccionPuerto(fd: PuertoTNSRequest): Observable<tnsPuertoResponse> {
    return this.http.post<tnsPuertoResponse>(`${environment.PATH_API}/mantenimiento/transaccionPuerto`, fd);
  }
  //#endregion

  //#region MANTENIMIENTO DE CAMPOS
  BuscarCampos(fd: BuscarCamposRequest): Observable<BuscarCamposResponse> {
    return this.http.post<BuscarPuertosResponse>(`${environment.PATH_API}/mantenimiento/buscarCampos`, fd);
  }
  transaccionCampo(fd: CamposTNSRequest): Observable<tnsCamposResponse> {
    return this.http.post<tnsCamposResponse>(`${environment.PATH_API}/mantenimiento/transaccionCampo`, fd);
  }
  listarServicios(fd: ListarServiciosRequest): Observable<listarServiciosResponse> {
    return this.http.post<listarServiciosResponse>(`${environment.PATH_API}/mantenimiento/buscarServicios`, fd);
  }
  //#endregion

  //#region MANTENIMIENTO DE ÁREAS
  ListarAreas(fd: BuscarAreasRequest): Observable<buscarAreasResponse> {
    return this.http.post<buscarAreasResponse>(`${environment.PATH_API}/mantenimiento/buscarAreas`, fd);
  }
  TransaccionAreas(fd: AreasTNSRequest): Observable<TransaccionAreasResponse> {
    return this.http.post<TransaccionAreasResponse>(`${environment.PATH_API}/mantenimiento/TransaccionAreas`, fd);
  }
  ListarCargos(fd: BuscarCargosRequest): Observable<buscarCargosResponse> {
    return this.http.post<buscarCargosResponse>(`${environment.PATH_API}/mantenimiento/buscarCargos`, fd);
  }
  TransaccionAreaCargo(fd: RelAreaCargoTNSRequest): Observable<RelAreaCargoTNSResponse> {
    return this.http.post<RelAreaCargoTNSResponse>(`${environment.PATH_API}/mantenimiento/ActualizarAreaCargo`, fd);
  }
  ListarCargosYAutorizadosByArea(fd: BuscarCargosYAutorizadosByAreaRequest): Observable<getCargoResAutorizarResponse> {
    return this.http.post<getCargoResAutorizarResponse>(`${environment.PATH_API}/mantenimiento/getCargosYResponsablesPorArea`, fd);
  }
  //#endregion

  //#region MANT EMPLEADOS
  ListarEmpleados(fd: ListarEmpleadosRequest): Observable<buscarEmpleadosResponse> {
    return this.http.post<buscarEmpleadosResponse>(`${environment.PATH_API}/mantenimiento/ListarEntidadEmpleado`, fd);
  }
  TransaccionEmpleados(fd: TransaccionEmpleadoRequest): Observable<TransaccionEmpleadoResponse> {
    return this.http.post<TransaccionEmpleadoResponse>(`${environment.PATH_API}/mantenimiento/TnsnEmpleados`, fd);
  }
  validacionUsrEmplWeb(fd: ValidacionUsrWebEmpleadosRequest): Observable<validacionUsWebEmpleadoResponse> {
    return this.http.post<validacionUsWebEmpleadoResponse>(`${environment.PATH_API}/mantenimiento/validarUsuarioWeb`, fd);
  }
  generarFichaPersonal(fd: GenerarFichaPersonalRequest): Observable<GenerarFichaPersonalResponse> {
    return this.http.post<GenerarFichaPersonalResponse>(`${environment.PATH_API}/mantenimiento/obtenerFichaByEmpleado`, fd);
  }
  getFormatosFichaPersonal(fd: getFormatosFichaEmpleadoRequest): Observable<getFormatosFichaEmplResponse> {
    return this.http.post<getFormatosFichaEmplResponse>(`${environment.PATH_API}/mantenimiento/getFormatoFicEmpl`, fd);
  }
  tnsFormatosFichaPersonal(fd: TnsFormatosFichaEmplRequest): Observable<TnsFormatosFichaEmplResponse> {
    return this.http.post<TnsFormatosFichaEmplResponse>(`${environment.PATH_API}/mantenimiento/tnsFormatoFicEmpl`, fd);
  }
  getArchivosEmpleado(fd: getArchivosEmpleadoRequest): Observable<getArchivosEmpleadoResponse> {
    return this.http.post<getArchivosEmpleadoResponse>(`${environment.PATH_API}/mantenimiento/getArchivosByEmpl`, fd);
  }
  //#endregion

  //#region MANT CARGOS
  TransaccionCargos(fd: CargosTNSRequest): Observable<CargoTNSResponse> {
    return this.http.post<CargoTNSResponse>(`${environment.PATH_API}/mantenimiento/TnsCargos`, fd);
  }
  //#endregion

  //#region AGENTE - PUERTO
  TransaccionAgenteContactos(fd: R_TransaccionAgentesRequest): Observable<ResponseTransaccionAgentesDTO> {
    return this.http.post<ResponseTransaccionAgentesDTO>(`${environment.PATH_API}/mantenimiento/TransaccionAgenteContactos`, fd);
  }
  TransaccionAgentePuerto(fd: R_TransaccionAgentePuertoRequest): Observable<ResponseTransaccionAgentePuertoDTO> {
    return this.http.post<ResponseTransaccionAgentePuertoDTO>(`${environment.PATH_API}/mantenimiento/TransaccionAgentePuerto`, fd);
  }
  listarBandejaAgenteContactos(fd: R_GetBandejaAgentesRequest): Observable<BandejaAgentesDTO> {
    return this.http.post<BandejaAgentesDTO>(`${environment.PATH_API}/mantenimiento/GetBandejaAgentes`, fd);
  }
  listarBandejaAgentePuertos(fd: R_GetBandejaAgentePuertoRequest): Observable<BandejaAgentePuertoDTO> {
    return this.http.post<BandejaAgentePuertoDTO>(`${environment.PATH_API}/mantenimiento/GetBandejaAgentePuerto`, fd);
  }
  listadosAgentePuerto(fd: R_GetListadosAgentePuertoRequest): Observable<ListadoAgentePuertoDTO> {
    return this.http.post<ListadoAgentePuertoDTO>(`${environment.PATH_API}/mantenimiento/GetListadosAgentePuerto`, fd);
  }
  getAgentePuertoById(fd: R_GetAgentePuertoByIdRequest): Observable<AgentePuertoByIdDTO> {
    return this.http.post<AgentePuertoByIdDTO>(`${environment.PATH_API}/mantenimiento/GetAgentePuertoById`, fd);
  }
  getAgenteContactosById(fd: R_GetAgenteContactosByIdRequest): Observable<AgenteContactosByIdDTO> {
    return this.http.post<AgenteContactosByIdDTO>(`${environment.PATH_API}/mantenimiento/GetAgenteContactosById`, fd);
  }
  //#endregion
}